import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionCarousel from "./Sections/YamamotoCarousel.jsx";
import SectionNavbars from "views/Components/Sections/SectionNavbars.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


class Components extends React.Component {
  render() {

    const { classes} = this.props;

    return (     
      
      <div> 
        <SectionNavbars/>  
                 
        <Parallax image={require("assets/img/Eide/Cows.jpg") }>       

          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Eide Fine Art</h1>
                  <h4><b>With its display of contemporary ceramics, paintings, and sculpture, the Eide Art Gallery 465 is one of Northern Arizona's finest art venues. Works by recognized fine artists from the United States and other countries are showcased in the gallery. The adobe complex overlooks the Verde River in Lower Sycamore Canyon.</b></h4>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
    

        <div className={classNames(classes.main, classes.mainRaised)} >
          <h3 className ={classNames(classes.subtitle)} style={artistStyles.bioText}>
              Yukio Yamamoto

             </h3>
          <p style={artistStyles.bioText}>Yukio Yamamoto came to be a welcomed guest of Northern Arizona University beginning in the mid-eighties. He first went to Arizona State University where Donald Bendel first met him. He was invited to visit Flagstaff and the University, he fell in love with this pine tree area which was not dissimilar to his home in Himeji, Japan. He together with Donald Bendel and many in Flagstaff built the Naborigama Kiln at the University. He had been a teacher and then much earlier had built his own ceramic facility and wood-fired kiiln which became a focal point in the Hemiji region.
Yukio studied the history of pottery of the past centuries of this well known Hemiji Castle domain.

          </p>

          <SectionCarousel/>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Components);



// WEBPACK FOOTER //
// ./src/views/Artists/Yamamoto.jsx